export const additionOption = {
  opt1: 'Remote access',
  opt2: 'Additional IBM Security',
  opt3: 'No additional requirements',
};

export const MaaS360 = {
  usecase1: 'Knowledge worker',
  usecase2: 'Frontline device management',
};

export const deviceOption = {
  opt1: '1-99',
  opt2: '100-500',
  opt3: '501-1000',
  opt4: 'more than 1000',
};

export const Que1ID = {
  Q3: ['Q3A1', 'Q3A2'],
};

export const marketplaceUrl = {
  essential:
    'https://www.ibm.com/marketplace/purchase/configuration/en/us/checkout?editionID=EIDRSD2Z',
  premier:
    'https://www.ibm.com/marketplace/purchase/configuration/en/us/checkout?editionID=EIDX56HE',
  enterprise:
    'https://www.ibm.com/marketplace/purchase/configuration/en/us/checkout?editionID=EID2P8FY',
  deluxe:
    'https://www.ibm.com/marketplace/purchase/configuration/en/us/checkout?editionID=EIDI5QXX',
  signUp: 'https://www.ibm.com/account/reg/signup?formid=urx-52171',
};

export const aws = {
  url: 'https://aws.amazon.com/marketplace/pp/prodview-5p7shpo6zhvwu',
};

export const osOption = {
  windows: 'Windows',
  macOS: 'MacOS',
  chromeOS: 'ChromeOS',
  iOS: 'iOS',
  android: 'Android',
  ipadOS: 'iPadOS',
  other: 'Other',
};

export const DELUX_MATCH = 'MaaS360 Deluxe';

export const DEVICE_THRESHOLD_AWS = 50;

// UT30 is an unique code to identify each widget in the BPPR ecosystem
export const UT30Maas360 = '30BIB';
